import { useCallback } from "react";
import { UpdateBrandStatusDTO } from "@src/domain/dto/brands";
import { UpdateBrandStatusUseCase } from "@src/application/useCases/brand";
import { BrandRepository } from "@src/infrastructure/repositories/brand";
import { OrganizationRepository } from "@src/infrastructure/repositories/organization";
import { GraphQlAdapter } from "@src/infrastructure/adapters/graphQl/GraphQl.adapter";
import { useOrganizationsData } from "@src/presentation/providers/OrganizationsDataProvider";

export function useUpdateBrandStatus() {
  const { applyBrandUpdate } = useOrganizationsData();

  return useCallback(
    async (brandId: number, brandIsActive: boolean) => {
      const payload = { brandId, brandIsActive };
      const validated = UpdateBrandStatusDTO.validate(payload);
      if (!validated.success) {
        console.error("UpdateBrandStatus validation failed", validated.error);
        throw new Error("UpdateBrandStatus validation failed");
      }
      const dto = new UpdateBrandStatusDTO(validated.data);
      const updatedBrand = await new UpdateBrandStatusUseCase(
        new BrandRepository(GraphQlAdapter.getInstance().getClient()),
      ).execute(dto);

      if (updatedBrand) {
        applyBrandUpdate(updatedBrand);
      }

      new OrganizationRepository(
        GraphQlAdapter.getInstance().getClient(),
      ).invalidateOrganizationsCache();
    },
    [applyBrandUpdate],
  );
}
